package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.FeedItem
import com.ijoin.data.model.PageResponse
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

class FeedApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/feed"

    suspend fun getUserFeed(page: Int = 0, size: Int = 10): Result<List<FeedItem>> {
        return try {
            val response = ApiClient.executeWithTokenRefresh {
                client.get(baseUrl) {
                    addAuthToken()
                    parameter("page", page)
                    parameter("size", size)
                }
            }
            // Check status before processing response
            if (response.status == HttpStatusCode.Forbidden) {
                // This should have been handled by executeWithTokenRefresh, but just in case
                return Result.failure(Exception("Authentication expired. Please login again."))
            }
            val pageResponse: PageResponse<FeedItem?> = response.body()
            Result.success(pageResponse.content.filterNotNull())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun generateFeed(): Result<Unit> {
        return try {
            ApiClient.executeWithTokenRefresh {
                client.post("$baseUrl/generate") {
                    addAuthToken()
                }
            }
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
